import React, { useMemo, useState } from 'react';
import { Dialog, List, ListItemButton, ListItemText, TextField, Typography } from '@mui/material';

export interface PaletteAction { id: string; label: string; keys?: string; run: () => void }

export default function CommandPalette({ open, onClose, actions }: { open: boolean; onClose: () => void; actions: PaletteAction[] }) {
  const [q, setQ] = useState('');
  const [cursor, setCursor] = useState(0);
  const visible = useMemo(
    () => actions.filter(a => a.label.toLowerCase().includes(q.toLowerCase())),
    [actions, q],
  );
  const run = (a?: PaletteAction) => { if (a) { onClose(); setQ(''); a.run(); } };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" TransitionProps={{ onExited: () => { setQ(''); setCursor(0); } }}>
      <TextField
        autoFocus fullWidth placeholder="Type a command…" value={q}
        onChange={e => { setQ(e.target.value); setCursor(0); }}
        onKeyDown={e => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setCursor(c => Math.min(c + 1, visible.length - 1)); }
          if (e.key === 'ArrowUp') { e.preventDefault(); setCursor(c => Math.max(c - 1, 0)); }
          if (e.key === 'Enter') run(visible[cursor]);
        }}
        sx={{ p: 1 }}
      />
      <List dense sx={{ maxHeight: 320, overflow: 'auto' }}>
        {visible.map((a, i) => (
          <ListItemButton key={a.id} selected={i === cursor} onClick={() => run(a)}>
            <ListItemText primary={a.label} />
            {a.keys && <Typography variant="caption" sx={{ color: 'text.secondary' }}>{a.keys}</Typography>}
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
